<template>
  <div class="dialog-merchant-copy-jd-pay-channel-info-wrapper">
    <el-dialog
      :title="title()"
      :visible="visible"
      width="30%"
      @open="onDialogOpen"
      @close="onDialogClose">
      <el-form label-position="top" ref="form" :rules="formRule" :model="form">

        <el-form-item
          label="京东渠道信息源商户（被拷贝商户）"
          prop="srcMerchant"
          width="100%">
          <el-select
            v-model="form.srcMerchant"
            placeholder="请选择被拷贝商户"
            style="width: 100%"
            filterable>
            <el-option
              v-for="merchant in merchantList"
              :key="merchant.merchant_id"
              :label="`${merchant.merchant_id} - ${merchant.acct_name}`"
              :value="merchant.merchant_id" />
          </el-select>
        </el-form-item>

        <div class="submit-wrapper">
          <el-button
            type="danger"
            size="medium"
            @click="onFormSubmit">保存</el-button>
          <el-button
            size="medium"
            @click="onFormCancel">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import bankApi from '@/api/bankApi'

export default {
  name: 'DialogMerchantPayInfo',
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    copingMerchant: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      form: {
        srcMerchant: ''
      },
      formRule: {
        srcMerchant: [
          { required: true, message: '请选择支付渠道', trigger: 'change' }
        ]
      },

      merchantList: []
    }
  },
  computed: {
  },
  methods: {
    ...mapActions('bank', [
      'updateMerchantPayInfo'
    ]),

    title () {
      if (this.copingMerchant) {
        return `拷贝商户京东渠道信息（${this.copingMerchant.merchant_id} - ${this.copingMerchant.acct_name}）`
      }
      return '拷贝商户京东渠道信息'
    },

    async loadData () {
      try {
        const res = await bankApi.getMerchants(1, 9999)
        if (res.rcode !== 0) {
          this.$message({
            type: 'error',
            message: res.msg
          })
          return
        }

        this.merchantList = res.data.merchants
      } catch (err) {
        this.$message({
          type: 'error',
          message: `加载商户信息失败: ${err}`
        })
        console.log(err)
      }
    },

    async onFormSubmit () {
      try {
        await this.$refs['form'].validate()

        const res = await bankApi.copyJdChannelInfo(this.copingMerchant.merchant_id, this.form.srcMerchant)
        if (res.rcode !== 0) {
          this.$message({
            type: 'error',
            message: res.msg
          })
          return
        }
        this.$message({
          type: 'success',
          message: '拷贝商户京东支付渠道信息成功'
        })
        this.$emit('data-change')
        this.$emit('change', false)
      } catch (err) {
        console.log(err)
      }
    },
    onFormCancel () {
      this.$emit('change', false)
    },

    onDialogOpen () {
      this.loadData()
    },
    onDialogClose () {
      this.$emit('change', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-merchant-copy-jd-pay-channel-info-wrapper {

  .submit-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 18%;
    margin: 2rem auto 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bank/DialogMerchantCopyJdPayChannelInfo.vue